import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MobileAppService } from '../../services';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

type StoreType = 'App Store' | 'Google Play';

@Component({
    selector: 'lib-app-update-modal',
    standalone: true,
    imports: [CommonModule, IonicModule, SvgIconComponent],
    templateUrl: './app-update-modal.component.html',
    styleUrl: './app-update-modal.component.scss'
})
export class AppUpdateModalComponent {
    mobileAppService = inject(MobileAppService);
    protected readonly storeText: Signal<StoreType> = computed(() => {
        if (this.mobileAppService.ios) {
            return 'App Store';
        }

        return 'Google Play';
    });
}
